<template>
  <div
    class="polish__card"
    :class="{'polish-selected': selectedPolish&&selectedPolish.id == polish.id}"
    @click="onHandlePolish"
  >
    <div
      class="polish__image"
      v-if="polish.image"
      :style="{backgroundImage: `url(${polish.image})`}"
    >
      <i
        v-if="selectedPolish&&selectedPolish.id == polish.id"
        class="fas fa-check text-red-500"
      ></i>
    </div>
    <div
      class="polish__no-image"
      v-else
    ><i
        v-if="selectedPolish&&selectedPolish.id == polish.id"
        class="fas fa-check text-red-500"
      ></i></div>
    <div class="polish__info">
      <div class="polish__name font-bold mb-1">{{ polish.name }}</div>
      <div class="polish__description text-sm mb-1">{{ polish.description }}</div>
      <div class="polish__price font-bold">{{ $t('main.price') }}: {{ $toCurrency(polish.price) }}</div>
    </div>

  </div>
</template>
<script>
export default {
  name: "PolishCard",
  props: {
    polish: {
      type: Object,
      required: true,
    },
    selected: {
      type: Object,
      default: null,
    },
  },
  computed: {
    selectedPolish() {
      return this.selected && this.selected.polish;
    },
  },
  methods: {
    onHandlePolish() {
      if (
        !this.selectedPolish ||
        this.selectedPolish == "undefined" ||
        this.selectedPolish.id != this.polish.id
      ) {
        this.$store.dispatch(
          "clientOrder/updateElementPolish",
          { element_id: this.selected.element_id, polish: this.polish },
          { root: true }
        );
      } else {
        this.$store.dispatch(
          "clientOrder/updateElementPolish",
          { element_id: this.selected.element_id, polish: null },
          { root: true }
        );
      }
    },
  },
};
</script>
<style scoped>
.polish__card {
  display: grid;
  grid-template-columns: max-content max-content;
  column-gap: 1rem;
  cursor: pointer;
}
.polish__card + .polish__card {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #cfe2e8;
}
.polish__image,
.polish__no-image {
  border: 1px solid #bcbcbc;
}
.polish__image {
  width: 120px;
  height: 120px;
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  text-align: right;
  padding: 1px;
}
.polish__no-image {
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.polish__card.polish-selected .polish__no-image,
.polish__card.polish-selected .polish__image {
  border-color: #ff0000;
  border-width: 2px;
}
</style>
